class BESSAppAPICaller {

    constructor(owner, apiBase, csrfToken) {
        this.owner = owner;
        this.apiBase = apiBase;
        this.csrfToken = nullIfUndefined(csrfToken);
    }

    /*
     * options:
     *   action
     *   args
     *   data
     *   formData
     *   onOK
     *   onError
     *   onResult
     */
    doCall(path, option) {

        //prod
        let url = this.apiBase + path;

        let handler = new BESSAppAPICallHandler(this, path, option);
        option.formData = nullIfUndefined(option.formData);
        option.data = nullIfUndefined(option.data);
        option.file = nullIfUndefined(option.file);
        option.onResult = nullIfUndefined(option.onResult);
        option.onError = nullIfUndefined(option.onError);
        let isForm = option.formData !== null;
        let isJSON = option.data !== null;
        let isFile = option.file !== null;
        let data = isFile ? this.toFileData(option) : isForm ? option.formData : isJSON ? JSON.stringify(option.data) : option.args;
        let cache = false;
        if (option.cache !== undefined) {
            cache = option.cache;
        }
        let contentType = isJSON ? "application/json; charset=utf-8" : "application/x-www-form-urlencoded; charset=UTF-8";
        let dataType = isJSON ? "json" : null;
        this.owner.log(option.type + ':' + url, isForm ? option.formData : isJSON ? option.data : option.args);

        let headers = {};
        if (this.csrfToken !== null) {
            headers = {"X-CSRFToken": this.csrfToken};
        }

        $.ajax({
            type: option.type,
            url: url,
            data: data,
            cache: cache,
            contentType: isFile ? false : contentType,
            processData: !isFile,
            dataType: dataType,
            success: handler.onSuccess.bind(handler),
            error: handler.onError.bind(handler),
            headers: headers
        }, "json");
    };

    get(path, options) {
        options.type = "GET";
        this.doCall(path, options);
    };

    post(path, options) {
        options.type = "POST";
        this.doCall(path, options);
    };


    toFileData(option) {
        let data = new FormData();
        data.append('FILE', option.file);
        $.each(option.data, function (key, value) {
            data.append(key, value);
        });
        return data;
    }
}

class BESSAppAPICallHandler {

    constructor(api, path, option) {
        this.option = option;
        this.api = api;
        this.path = path;
    }

    onSuccess(data) {
        this.api.owner.log('API SUCCESS', {
            'path': this.path,
            'data': data,
        });
        if (this.option.onResult !== null) {
            this.option.onResult(data);
        }
    };

    onError(data) {
        this.api.owner.log('API ERROR', {
            'path': this.path,
            'data': data,
        });
        if (this.option.onError !== null) {
            this.option.onError();
        }
    };
}
